import type { App } from "@open-booking/server";
import type { UpdateUserPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type UpdateProfileResponse = App["~Routes"]["user"]["me"]["put"]["response"]["200"];

export const tenantProfileApi = createApi({
	reducerPath: "tenantProfileApi",
	baseQuery: edenBaseQuery(),
	endpoints: (builder) => ({
		updateProfile: builder.mutation<UpdateProfileResponse, UpdateUserPayload>({
			query:
				(payload): EdenCall<UpdateProfileResponse> =>
				(client) =>
					client.user.me.put(payload),
		}),
	}),
});

export const { useUpdateProfileMutation } = tenantProfileApi;
